// extracted by mini-css-extract-plugin
module.exports = {"option":"styles_option__xeuWD","option__selected":"styles_option__selected__5m4nD"};